<template>
  <v-container>
    <v-row
      class="mt-7"
      justify="center"
      no-gutters
    >

                <!--------------------------------->
                <!--        Set Page Size        -->
                <!--------------------------------->
      <v-col
        cols="12"
        class="ma-0 pa-0"
      >

                <!--------------------------------->
                <!--  Dialog For Add Individual  -->
                <!--------------------------------->
        <v-dialog
          v-model="newIndividual"
          persistent
          width="500"
        >
          <template v-slot:activator="{ on }">

                <!--------------------------------->
                <!--       Individual Card       -->
                <!--------------------------------->
            <v-row
              no-gutters
            >
                <!--------------------------------->
                <!--     Individual Iterator     -->
                <!--------------------------------->
              <v-expansion-panels
                v-model="individualSelection"
                hover
                popout
                focusable
                class="px-2"
              >

                <v-expansion-panel
                  v-for="(individual,i) in individuals"
                  :key="i"
                >

                <!--------------------------------->
                <!-- Dialog For Remove Individual-->
                <!--------------------------------->
                  <v-dialog
                    v-model="deleteIndividual"
                    persistent
                    width="500"
                  >
                    <template v-slot:activator="{ on }">

                <!--   Expansion Panel Header   -->
                      <v-expansion-panel-header
                        class="pl-2"
                      >
                        <v-row
                          no-gutters
                          align="center"
                        >
                            <v-col
                                v-if="i > 0"
                                class="shrink"
                            >
                                <v-btn
                                    icon
                                    class="white--text"
                                    color = 'red'
                                    @click.prevent="queueRemoveIndividual(individual.name)"
                                    v-on ="on"
                                >
                                    <v-icon
                                        medium
                                    >
                                        delete_forever
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                v-if="i == 0"
                                class="shrink ml-1 mr-2"
                            >
                                <v-icon
                                    color="#74cf74"
                                    medium
                                >
                                    account_circle
                                </v-icon>
                            </v-col>
                          <v-col>
                            <h4>
                              {{individual.name}}
                            </h4>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>

                    </template>

                <!--       Dialog Content       -->
                    <v-card
                      class="pb-5"
                      style="overflow-y: hidden; overflow-x: hidden"
                    >
                      <v-row
                        class="grey lighten-3"
                      >
                        <v-card-title
                          class="headline ml-3"
                          primary-title
                        >
                            Remove Person
                        </v-card-title>
                        <v-btn
                          absolute
                          small
                          fab
                          class="mr-3 text-right"
                          style="top: 10px; right: 10px;"
                          @click.prevent="cancelRemoveIndividual"
                        >
                          <v-icon>
                            close
                          </v-icon>
                        </v-btn>
                      </v-row>
                      <v-row
                        no-gutters
                        class="my-5"
                        justify="center"
                      >
                        Remove {{individualName}}?
                      </v-row>
                      <v-row
                        no-gutters
                        justify="space-between"
                        class="px-5"
                      >
                        <v-btn
                          @click.prevent="cancelRemoveIndividual"
                        >
                          CANCEL
                        </v-btn>
                        <v-btn
                          @click.prevent="removeIndividual(individualName)"
                        >
                          REMOVE
                        </v-btn>
                      </v-row>
                    </v-card>
                  </v-dialog>

                <!--  Expansion Panel Content  -->
                    <v-expansion-panel-content>
                        <v-container flex>
                        <v-row>
                            <v-text-field
                                v-model="individual.name"
                                :label="i == 0 ? 'Your Name' : 'Name'"
                                class="mx-2 mt-5 mb-0 pa-0"
                                v-on:input="individualChangeMade([i,true])"
                            ></v-text-field>
                        </v-row>

                        <v-row
                            class="flex-nowrap"
                        >
                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >                
                                <v-text-field
                                    v-model="individual.birth_year"
                                    label="Birth Year"
                                    type="number"
                                    class="mx-2 my-0 pa-0"
                                    v-on:input="individualChangeMade([i,true])"
                                ></v-text-field>
                            </v-col>

                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                                <v-select
                                    v-model="individual.gender"
                                    :items="['M','F']"
                                    label="Gender"
                                    class="mx-2 my-0 pa-0"
                                    v-on:input="individualChangeMade([i,true])"
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="(new Date().getFullYear() - individual.birth_year) >= 16"
                            class="flex-nowrap"
                        >
                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                                <v-text-field
                                v-model="individual.height_ft"
                                label="Height"
                                type="number"
                                suffix="ft"
                                class="mx-2 my-0 pa-0"
                                v-on:input="individualChangeMade([i,true])"
                                ></v-text-field>
                            </v-col>

                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                                <v-text-field
                                v-model="individual.height_in"
                                label="Height"
                                type="number"
                                suffix="in"
                                class="mx-2 my-0 pa-0"
                                v-on:input="individualChangeMade([i,true])"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="(new Date().getFullYear() - individual.birth_year) >= 16"
                        >
                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                            <v-text-field
                                v-model="individual.weight_lb"
                                label="Weight (lb)"
                                type="number"
                                suffix="lbs"
                                class="mx-2 my-0 pa-0"
                                v-on:input="individualChangeMade([i,true])"
                            ></v-text-field>
                            </v-col>

                            <v-col
                                cols="6"
                                class="ma-0 pa-0"
                            >
                                <v-text-field
                                    v-model="individual.weight_goal"
                                    label="Goal Weight"
                                    type="number"
                                    suffix="lbs"
                                    class="mx-2 my-0 pa-0"
                                    v-on:input="individualChangeMade([i,true])"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row
                            v-if="!((new Date().getFullYear() - individual.birth_year) < 16)"
                        >
                            <v-select
                            v-model="individual.activity_level"
                            :items="['sedentary','light','active','very active']"
                            label="Activity Level"
                            class="mx-2 my-0 pa-0"
                            v-on:input="individualChangeMade([i,true])"
                            ></v-select>
                        </v-row>

                        <v-row
                            v-else
                        >
                            <v-select
                            v-model="individual.activity_level"
                            :items="['light','active','very active']"
                            label="Activity Level"
                            class="mx-2 my-0 pa-0"
                            v-on:input="individualChangeMade([i,true])"
                            ></v-select>
                        </v-row>

                        <v-row>
                            <v-text-field
                                v-model="individual.daily_calorie_target"
                                label="Daily Calories"
                                type="number"
                                class="mx-2 my-0 pa-0"
                                hide-details
                                v-on:input="individualChangeMade([i,true])"
                            ></v-text-field>
                        </v-row>
                        <v-row
                            justify="center"
                            class="mt-1 pa-0"
                        >
                            <v-col
                                class="ma-0 pa-0"
                                style="font-size: 0.8em; font-weight: 300; color: #212121; letter-spacing: 1px; text-align: center;"
                            >
                                Suggested: {{individual.suggested_calories}}
                            </v-col>
                        </v-row>
                        <v-row
                            no-gutters
                            class="mt-3"
                            justify="end"
                        > 
                            <v-btn
                                v-if="individual.needToSave"
                                color="blue"
                                class="white--text"
                                @click.prevent="updateIndividual({
                                    name: individual.name,
                                    gender: individual.gender,
                                    birth_year: individual.birth_year,
                                    weight_lb: individual.weight_lb,
                                    height_ft: individual.height_ft,
                                    height_in: individual.height_in,
                                    activity_level: individual.activity_level,
                                    goal_weight: individual.weight_goal,
                                    daily_calorie_target: individual.daily_calorie_target,
                                    suggested_calories: individual.suggested_calories,
                                    index: i
                                })"
                            >
                                Save
                            </v-btn>
                        </v-row>

                        </v-container>
                    </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

                <!--------------------------------->
                <!--    Add Individual Dialog    -->
                <!--------------------------------->
              <v-row
                class="mx-5 mt-5"
                justify="end"
                no-gutters
              >
                <v-btn
                  fab
                  dark
                  small
                  color="blue"
                  @click.prevent="newIndividual = true"
                  v-on="on"
                >
                  <v-icon
                    medium color="white"
                  >
                    person_add
                  </v-icon>
                </v-btn>  
              </v-row>
            </v-row>
          </template>

                <!--       Dialog Content       -->
          <AddPerson/>
        </v-dialog>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AddPerson from '@/components/people/AddPerson.vue'
        
export default {
    components: {
        AddPerson,
    },
    data: () => ({
        individualSelection: [],
        deleteIndividual: false,
        individualName: null,
    }),

    methods: {
        queueRemoveIndividual(value){
            this.deleteIndividual = true;
            this.individualName = value;
        },

        cancelRemoveIndividual() {
            this.deleteIndividual = false;
            this.individualSelection = null;
            this.individualName = null;
        },

        cancelAddIndividual() {
          this.newIndividual = false;
        },

        removeIndividual(value) {
            this.$store.dispatch('data/removeIndividual',value);
            this.deleteIndividual = false;
            this.individualName = null;
        },

        individualChangeMade: function(value) {
            this.$store.dispatch('data/individualChangeMade',value);
        },

        updateIndividual: function(value) {
            this.$store.dispatch('data/updateIndividual',value);
            this.individualSelection = null;
        },

        

        
    },

    computed: {
        newIndividual: {
            get() {
                return this.$store.getters['data/newPerson'];
            },
            set(value) {
                this.$store.dispatch('data/updateNewPerson',value);
            }
        },

        individuals() {
            return this.$store.getters['data/individual'];
        },


    },

}
</script>
